import {createToast} from "../utils/toasts";

export const initShareLinks = (selector: string = '.link--share') => {
	const ShareLinksObject = {
		_init(): void {
			this._bindClass();
			this._bindEvents();
		},
		_bindClass(): void {
			this.onClick = this.onClick.bind(this);
		},
		_bindEvents(): void {
			document.querySelectorAll<HTMLAnchorElement>(selector).forEach((link) => {
				if (link.dataset.shareInitialized === 'true') {
					return;
				}

				link.dataset.shareInitialized = 'true';
				link.addEventListener('click', this.onClick);
			});
		},
		async onClick(event: Event): Promise<void> {
			const link = event.currentTarget as HTMLAnchorElement;
			const href = link.href;

			if (!href) {
				return;
			}

			event.preventDefault();

			if (typeof navigator.share === 'function') {
				try {
					await navigator.share({
						title: link.dataset.shareTitle || document.title,
						url: href,
					});
					return;
				} catch (error) {
					if (error instanceof DOMException && error.name === 'AbortError') {
						return;
					}
				}
			}

			try {
				await this.copyToClipboard(href);
				createToast('Link wurde kopiert.');
			} catch {
				createToast('Link konnte nicht kopiert werden.');
			}
		},
		async copyToClipboard(value: string): Promise<void> {
			if (navigator.clipboard && window.isSecureContext) {
				await navigator.clipboard.writeText(value);
				return;
			}

			const textarea = document.createElement('textarea');
			textarea.value = value;
			textarea.setAttribute('readonly', '');
			textarea.style.position = 'fixed';
			textarea.style.opacity = '0';
			document.body.appendChild(textarea);
			textarea.select();

			const wasCopied = document.execCommand('copy');
			textarea.remove();

			if (!wasCopied) {
				throw new Error('Copying the share URL failed.');
			}
		},
	};

	ShareLinksObject._init();
	return ShareLinksObject;
};
